var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-auto",attrs:{"to":_vm.to,"outlined":"","rounded":""}},[_vm._v(_vm._s(_vm.$t('analytics.view_all')))])
}
var staticRenderFns = []

export { render, staticRenderFns }